/**
 * Contexto para gestión de sucursal activa
 * Permite compartir la sucursal seleccionada en toda la aplicación
 */
import React, { createContext, useContext, useState, useEffect } from "react";
import { storage, STORAGE_KEYS } from "../api/config";
import api from "../api/endpoints";

const BranchContext = createContext();

export const useBranch = () => {
  const context = useContext(BranchContext);
  if (!context) {
    throw new Error("useBranch debe usarse dentro de BranchProvider");
  }
  return context;
};

export const BranchProvider = ({ children }) => {
  const [activeBranch, setActiveBranch] = useState(null);
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);

  // Cargar sucursales y sucursal activa al iniciar
  useEffect(() => {
    const loadBranches = async () => {
      try {
        setLoading(true);
        const branchesData = await api.branches.getBranchesSelect();
        setBranches(branchesData);
        
        // Cargar sucursal activa desde localStorage
        const savedBranchId = storage.get(STORAGE_KEYS.ACTIVE_BRANCH);
        if (savedBranchId && branchesData.find((b) => b.value === savedBranchId)) {
          setActiveBranch(savedBranchId);
        } else if (branchesData.length > 0) {
          // Si no hay guardada, usar la primera
          setActiveBranch(branchesData[0].value);
        }
      } catch (error) {
        console.error("Error cargando sucursales:", error);
      } finally {
        setLoading(false);
      }
    };

    loadBranches();
  }, []);

  // Guardar sucursal activa cuando cambia
  useEffect(() => {
    if (activeBranch) {
      try {
        storage.set(STORAGE_KEYS.ACTIVE_BRANCH, activeBranch);
        // Verificar que se guardó correctamente
        const savedBranch = storage.get(STORAGE_KEYS.ACTIVE_BRANCH);
        if (savedBranch !== activeBranch) {
          console.error("Error: La sucursal activa no se guardó correctamente");
        }
      } catch (error) {
        console.error("Error guardando sucursal activa:", error);
        // No lanzar el error para que la app pueda seguir funcionando
      }
    }
  }, [activeBranch]);

  // Recargar sucursales
  const reloadBranches = async () => {
    try {
      const branchesData = await api.branches.getBranchesSelect();
      setBranches(branchesData);
    } catch (error) {
      console.error("Error recargando sucursales:", error);
    }
  };

  const value = {
    activeBranch,
    setActiveBranch,
    branches,
    reloadBranches,
    loading,
  };

  return <BranchContext.Provider value={value}>{children}</BranchContext.Provider>;
};

